import React, { useCallback } from 'react';
import classNames from 'clsx';
import ArrowRight from 'mdi-material-ui/ArrowRight';

import { LabelEnum, TerminationGeneratorEnum } from 'app/shared/enums';
import { TerminationGeneratorSuccessModal } from 'app/components/TerminationGeneratorSuccessModal';
import { TerminationGeneratorOnlineRedirectModal } from 'app/components/TerminationGeneratorOnlineRedirectModal';
import { Form } from 'app/components/Form';
import { FormPlaceholder } from 'app/components/FormPlaceholder';
import { DefaultFormActionButton } from 'app/components/DefaultFormActionButton';
import { isPrerendering } from 'app/shared/helpers/isPrerendering';
import { PageContentWrapper } from 'app/components/PageContentWrapper';
import { Sticky } from 'app/components/Sticky';
import { TerminationGeneratorSidebar } from 'app/components/TerminationGeneratorSidebar';

import { useTerminationGeneratorForm } from './useTerminationGeneratorForm';
import { useStyles } from './TerminationGeneratorForm.styles';

export default function TerminationGeneratorForm() {
  const classes = useStyles();

  const {
    formName,
    isLoaded,
    isSubmitting,
    isSubmitted,
    isSuccessModalOpened,
    isExpanded,
    isOnlineRedirectModalOpened,
    extraValidation,
    onSubmit,
    onSuccessModalClose,
    onOnlineRedirectModalRedirect,
    onOnlineRedirectModalContinue,
    onOnlineRedirectModalClose,
  } = useTerminationGeneratorForm();

  const renderFooter = useCallback(
    ({ children }) => (
      <div
        className={classNames({
          [classes.footer]: isExpanded,
          [classes.footerFirstScreen]: !isExpanded,
        })}
      >
        {children}
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExpanded]
  );

  const renderActionButton = useCallback(
    ({ isLoading, title, ...rest }) => (
      <DefaultFormActionButton
        {...rest}
        isLoading={isLoading}
        title={!isExpanded ? TerminationGeneratorEnum.Next : title}
        className={classes.submit}
        suffixIcon={!isExpanded ? ArrowRight : undefined}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExpanded]
  );

  return (
    <>
      <PageContentWrapper
        className={classes.pageContentWrapper}
        mainContent={
          <div className={classNames({ [classes.mainContent]: !isExpanded })}>
            {isLoaded && !isPrerendering ? (
              <Form
                formName={formName}
                actionButtonTitle={
                  isSubmitted
                    ? LabelEnum.Sent
                    : LabelEnum.SendGeneratedTermination
                }
                action={onSubmit}
                extraValidation={extraValidation}
                isLoading={isSubmitting}
                renderFooter={renderFooter}
                renderActionButton={renderActionButton}
                disabled={isSubmitted}
                SectionProps={{
                  classes: {
                    formRow: !isExpanded ? classes.formRow : undefined,
                  },
                }}
              />
            ) : (
              <div className={classes.placeholder}>
                <FormPlaceholder showLoadingAnimation={!isPrerendering} />
              </div>
            )}
          </div>
        }
        sidebar={
          isExpanded ? (
            <Sticky>
              <TerminationGeneratorSidebar />
            </Sticky>
          ) : undefined
        }
      />

      {isOnlineRedirectModalOpened && (
        <TerminationGeneratorOnlineRedirectModal
          onRedirect={onOnlineRedirectModalRedirect}
          onContinue={onOnlineRedirectModalContinue}
          onClose={onOnlineRedirectModalClose}
        />
      )}
      {isSuccessModalOpened && (
        <TerminationGeneratorSuccessModal onClose={onSuccessModalClose} />
      )}
    </>
  );
}
